import { NgModule } from '@angular/core';
import { 
    MatToolbarModule,
    MatMenuModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSnackBarModule,
    MatSortModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatListModule
} from '@angular/material';

const modules = [
    MatToolbarModule,
    MatMenuModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSnackBarModule,
    MatSortModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatListModule
];

@NgModule({
    imports: modules,
    exports: modules
})
export class AppMaterialModule {

}


// WEBPACK FOOTER //
// C:/Users/mybrokenwalls/workspace/mybrokenwalls/portfolio/src/app/app-material.module.ts